__turbopack_context__.v({
  "bottomContentItemDetail": "MediaThumbnailContentBottom-module__Fvp_xa__bottomContentItemDetail",
  "bottomContentListItem": "MediaThumbnailContentBottom-module__Fvp_xa__bottomContentListItem",
  "container": "MediaThumbnailContentBottom-module__Fvp_xa__container",
  "containerItemDetail": "MediaThumbnailContentBottom-module__Fvp_xa__containerItemDetail",
  "containerListItem": "MediaThumbnailContentBottom-module__Fvp_xa__containerListItem",
  "row": "MediaThumbnailContentBottom-module__Fvp_xa__row",
  "rowFlexEnd": "MediaThumbnailContentBottom-module__Fvp_xa__rowFlexEnd",
  "rowSpaceBetween": "MediaThumbnailContentBottom-module__Fvp_xa__rowSpaceBetween",
});
